export const styles = {
  space: [],
  sizes: [],
  palette: {
    white: '#ffffff',

    gray: {
      50: '#fdfdfd',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#E0E0E0',
      400: '#BDBDBD',
      main: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121'
    },

    black: '#000000',

    primary: {
      light: '#0AA2E8',
      400: '#0987C1',
      main: '#076F9F',
      dark: '#07567B',
      700: '#064460'
    },

    secondary: {
      light: '#74D6F4',
      400: '#55CDF1',
      main: '#3DC6EF',
      dark: '#15AEDC',
      700: '#1395BC'
    },

    green: {
      400: '#43A047'
    },

    status: {
      inCaptation: '#076F9F',
      inFormalization: '#663CCC',
      concluded: '#4AB34E',
      waitingList: '#F6B344',
      defaulting: '#FD4646',
      late: '#F6B344',
      compliant: '#076F9F',
      completed: '#4AB34E'
    },

    action: {
      active: '#616161',
      disabled: '#BDBDBD'
    },

    error: {
      main: '#D93025'
    },

    text: {
      primary: '#424242',
      secondary: '#212121'
    }
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    h1: {
      fontSize: 48,
      lineHeight: '64px'
    },
    h2: {
      fontSize: 32,
      lineHeight: '48px'
    },
    h3: {
      fontSize: 24,
      lineHeight: '40px',
      fontWeight: 600
    },
    h4: {
      fontWeight: 600,
      fontSize: 18,
      lineHeight: '26px'
    },
    subtitle1: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 'normal'
    },
    subtitle2: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 600
    },
    body1: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 400
    },
    body2: {
      fontSize: 14,
      lineHeight: '24px'
    },
    caption: {
      fontSize: 12,
      lineHeight: '16px'
    },
    button: {
      fontSize: 14,
      lineHeight: '24px',
      fontWeight: 600
    },
    semiBold: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '24px'
    }
  }
}
